<template>
  <div id="div-with-loading" class="vs-con-loading__container">
    <!-- Add Reseller -->
    <div class="vx-row">
      <vx-card class="centered-page-container">
        <div class="vx-row flex-wrap px-5">
          <h2 class="partner-page-title"> Add Reseller </h2>
        </div>

        <hr>

        <div>
          <vs-tabs class="mt-2 add-partner-tabs">
            <vs-tab label="Registrar & Reseller Details">
              <hr class="mt-2">
              <div class="tab-text">
                <div class="vx-row mt-8">
                  <div class="vx-col">
                    <h5 class="tab-title">Registrar Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4" v-for="(regDetail, index) in formDataReseller['registrarDetails']" :key="`ParentReg-${index}`">
                    <label class="vs-input--label inline-flex pb-2">Parent Registrar {{ index == 0 ? '*' : ''}}</label>
                    <div class="flex">
                      <v-select
                        :data-vv-name="`Parent Registrar-`+index"
                        :name="`Parent Registrar-`+index"
                        class="w-full"
                        :class="errors.has(`Parent Registrar-`+index) ? 'select-required-error' : ''"
                        v-model="regDetail.parentRegistrar"
                        :options="formCustomUniqueRegs"
                        :closeOnSelect="true"
                        :clearable="false"
                        v-validate="!index && !regDetail.parentRegistrar ? 'required' : ''"
                        data-vv-validate-on="change"
                        :required="!index && !regDetail.parentRegistrar"
                        @input="setAllToView()"></v-select>

                        <i v-show="formDataReseller['registrarDetails'].length > 1" class="vs-icon notranslate icon-scale feather icon-x null cursor-pointer mt-2 ml-2" @click="removeParentReg(index)"></i>
                    </div>
                          
                    <span v-if="errors.has(`Parent Registrar-`+index)" class="select-required-error--span span-text-validation"> Required field </span>
                    <vs-button size="small" color="black" class="mt-2" :type="`${regDetail['viewDetails'] ? 'filled' : 'border'}`" :disabled="!regDetail.parentRegistrar" @click="toggleViewDetails(index)">{{ regDetail['viewDetails'] ? 'View Details' : 'Hide Details'}}</vs-button>
                  </div>


                  <div class="vx-col w-1/4 mt-6">
                    <vs-button color="black" class="mt-2 add-more-btn" type="filled" icon-pack="feather" icon="icon-plus" @click="addParentReg()">Add</vs-button>
                  </div>
                </div>

                <div v-if="showRegDetails">
                  <div class="vx-row mt-4">
                    <div class="vx-col w-1/4">
                      <label class="vs-input--label inline-flex pb-2">Account Manager</label>
                      <vs-input
                        class="w-full"
                        name="Reg Account Manager"
                        v-bind:readonly="true"
                        v-model="formDataReseller['registrarDetails'][regDetailsIndex]['accountManager']" />
                    </div>

                    <div class="vx-col w-1/4">
                      <label class="vs-input--label inline-flex pb-2">Country</label>
                      <vs-input
                        class="w-full"
                        name="Reg Country"
                        v-bind:readonly="true"
                        v-model="formDataReseller['registrarDetails'][regDetailsIndex]['country']" />
                    </div>

                    <div class="vx-col w-1/2" v-for="(id, index) in formDataReseller['registrarDetails'][regDetailsIndex]['cnicIanaIDs']" :key="`CNICIANA-${index}`" :class="index ? 'mt-1' : ''">
                      <div class="vx-row px-0">
                        <div class="vx-col w-1/2">
                          <label class="vs-input--label inline-flex pb-2">IANA ID</label>
                          <vs-input
                            class="w-full"
                            name="IANA ID"
                            v-bind:readonly="true"
                            v-model="id['iana_id']" />
                        </div>

                        <div class="vx-col w-1/2">
                          <label class="vs-input--label inline-flex pb-2">CNIC ID</label>
                          <vs-input
                            class="w-full"
                            name="CNIC ID"
                            v-bind:readonly="true"
                            v-model="id['cnic_id']" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <hr class="my-8">

                <div class="vx-row mt-6">
                  <div class="vx-col">
                    <h5 class="tab-title">Reseller Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Short Name *</label>
                    <!-- TODO: Character count error precedence over required error -->
                    <!-- NOTE: Backup regex if later special characters aren't allowed: v-validate="{ required: true, max:50, regex: /^[a-zA-Z0-9]+(?:[ ]?[a-zA-Z0-9]+)*$/ }" -->
                    <vs-input
                      class="w-full"
                      name="Reseller Short Name"
                      v-model="formDataReseller['resellerDetails']['resellerShortName']"
                      v-validate="{ required: !formDataReseller['resellerDetails']['resellerShortName'], max:50 }"
                      data-vv-validate-on="change"
                      :danger="errors.has('Reseller Short Name') || (formDataReseller['resellerDetails']['resellerShortName'] ? formDataReseller['resellerDetails']['resellerShortName'].length : 0) > 50"
                      :danger-text="errors.has('Reseller Short Name') ? (errors.items.find(x => x.field == 'Reseller Short Name').rule == 'required' ? 'Required field' : errors.items.find(x => x.field == 'Reseller Short Name').msg) : characterCount"/>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Account Manager *</label>
                      <v-select
                        name="Reseller Account Manager"
                        class="w-full"
                        v-model="formDataReseller['resellerDetails']['accountManager']"
                        :required="true"
                        v-validate="!formDataReseller['resellerDetails']['accountManager'] ? 'required' : ''"
                        :class="errors.has(`Reseller Account Manager`) ? 'select-required-error' : ''"
                        data-vv-validate-on="change"
                        mode="eager"
                        :options="formAMs"
                        :closeOnSelect="true"
                        :clearable="false"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Country</label>
                    <v-select
                        name="Reseller Country"
                        class="w-full"
                        v-model="formDataReseller['resellerDetails']['country']"
                        :options="formGeo"
                        :closeOnSelect="true"
                        :clearable="false"></v-select>
                  </div>
                  
                  <div class="vx-col w-1/4">
                  <label class="vs-input--label inline-flex pb-2">Website</label>
                    <vs-input
                      class="w-full"
                      name="Reseller Website"
                      v-model="formDataReseller['resellerDetails']['website']" 
                      v-validate="'url'"
                      mode="eager"
                      data-vv-validate-on="change"
                      :danger="formDataReseller['resellerDetails']['website'] ? errors.has('Reseller Website') : false"
                      :danger-text="'Invalid URL'"/>
                  </div>
                </div>

                <div class="vx-row mt-4">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Nameservers</label>
                    <treeselect name="client" class="w-full" v-model="formDataReseller['resellerDetails']['nameservers']" 
                    :async="true" :load-options="nameserverList" :multiple="true" :flat="true" 
                     :default-expand-level="1" :clearable="true" 
                    placeholder=""/>
                    <!-- <v-select
                      name="type"
                      class="w-full custom-multi-select"
                      v-model="formDataReseller['resellerDetails']['nameservers']"
                      :options="formNameservers"
                      :closeOnSelect="false"
                      :clearable="false"
                      :multiple="true"></v-select> -->
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label mt-2 pb-1 flex justify-between">
                      <span>Group Entity *</span>
                      <span class="mr-0">
                        <vx-tooltip text="The parent group name this partner belongs to" position="top">
                          <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null"></i>
                        </vx-tooltip>
                      </span>
                    </label>
                    <v-select
                    name="Group Entity"
                    class="w-full mt-1"
                    :class="errors.has('Group Entity') ? 'select-required-error' : ''"
                    v-model="formDataReseller['resellerDetails']['groupEntity']"
                    :options="formGroupEntity"
                    :closeOnSelect="true"
                    :clearable="false"
                    v-validate="!formDataReseller['resellerDetails']['groupEntity'] ? 'required' : ''"
                    mode="eager"
                    data-vv-validate-on="change"
                    :required="!formDataReseller['resellerDetails']['groupEntity']"></v-select>

                    <span v-if="errors.has('Group Entity')" class="select-required-error--span span-text-validation"> Required field </span>
                  </div>

                  <div class="vx-col w-1/8 mt-6 px-0">
                    <vx-tooltip text="Choose from the list or add a new group entity if it’s missing" position="top">
                      <vs-button color="black" class="mt-3 add-more-btn" type="filled" icon-pack="feather" icon="icon-plus" @click="addNewGroupEntity()"></vs-button>
                    </vx-tooltip>
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row mt-6">
                  <div class="vx-col">
                    <h5 class="tab-title">Point of Contact Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-4" v-for="(contactDetail, index) in formDataReseller['resellerDetails']['contactDetails']" :key="`ContactDetail-${index}`">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Contact {{ index + 1 }} Name {{ index == 0 ? '*' : ''}}</label>
                    <vs-input
                      class="w-full"
                      :data-vv-name="`Contact Name-`+index"
                      v-model="contactDetail['name']" 
                      v-validate="!index && !contactDetail['name'] ? 'required' : ''"
                      data-vv-validate-on="change"
                      :danger="errors.has(`Contact Name-`+index)"
                      danger-text="Required field"/>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Contact {{ index + 1 }} Email {{ index == 0 ? '*' : ''}}</label>
                    <div class="flex">
                      <vs-input
                        class="w-full"
                        :data-vv-name="`Contact Email-`+index"
                        v-model="contactDetail['email']"
                        v-validate="!index && !contactDetail['email'] ? 'required|email' : 'email'"
                        data-vv-validate-on="change"
                        :danger="errors.has(`Contact Email-`+index)"
                        :danger-text="errors.has(`Contact Email-`+index) ? (errors.items.find(x => x.field == `Contact Email-`+index).rule == 'required' ? 'Required field' : 'Invalid email') : ''"/>
                      <i v-show="formDataReseller['resellerDetails']['contactDetails'].length > 1" class="vs-icon notranslate icon-scale feather icon-x null cursor-pointer mt-2 ml-2" @click="removeContactDetail(index)"></i>
                    </div>
                  </div>

                  <div v-if="index == formDataReseller['resellerDetails']['contactDetails'].length - 1" class="vx-col w-1/4 mt-6">
                    <vs-button color="black" class="mt-2 add-more-btn" type="filled" icon-pack="feather" icon="icon-plus" @click="addContactDetails()">Add</vs-button>
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row">
                  <vs-button class="ml-auto" button="submit" type="filled" icon-pack="feather" icon="icon-arrow-right" icon-after @click="nextToPayment">Next</vs-button>
                </div>
              </div>
              <!--  -->
            </vs-tab>

            <vs-tab label="Billing & Payment" :disabled="!flags['previousTabsValid']">
              <hr class="mt-2">

              <form class="tab-text" @submit.prevent="save()">
                <div class="vx-row mt-8">
                  <div class="vx-col">
                    <h5 class="tab-title">Payment Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4">
                  <label class="vs-input--label inline-flex pb-2">List Based</label>
                    <v-select
                    name="List Based"
                    class="w-full"
                    v-model="formDataReseller['paymentDetails']['listBased']"
                    :options="formBooleanValues"
                    :closeOnSelect="true"
                    :clearable="false"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label pb-2 flex justify-between">
                      <span>List Frequency</span>
                      <span class="mr-0">
                        <vx-tooltip text="Select NA if its not a rebate partner" position="top" class="tooltip-in-popup">
                            <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null"></i>
                        </vx-tooltip>
                      </span>
                    </label>
                    <v-select
                    name="List Frequency"
                    class="w-full mt-1"
                    v-model="formDataReseller['paymentDetails']['listFrequency']"
                    :options="formListFrequency"
                    :closeOnSelect="true"
                    :clearable="false"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Payment Mode</label>
                    <v-select
                    name="Payment Mode"
                    class="w-full"
                    v-model="formDataReseller['paymentDetails']['paymentMode']"
                    :options="formPaymentMode"
                    :closeOnSelect="true"
                    :clearable="false"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Custom List</label>
                    <v-select
                    name="Custom List"
                    class="w-full"
                    v-model="formDataReseller['paymentDetails']['customList']"
                    :options="formBooleanValues"
                    :closeOnSelect="true"
                    :clearable="false"></v-select>
                  </div>
                </div>

                <div class="vx-row mt-4" v-if="formDataReseller['paymentDetails']['paymentMode'] && formDataReseller['paymentDetails']['paymentMode']['value'] == 'bank'">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Billing Entity *</label>
                    <v-select
                    name="Billing Entity"
                    class="w-full"
                    :class="errors.has('Billing Entity') ? 'select-required-error' : ''"
                    v-model="formDataReseller['paymentDetails']['billingEntity']"
                    :options="formBillingEntity"
                    :closeOnSelect="true"
                    :clearable="false"
                    v-validate="formDataReseller['paymentDetails']['paymentMode'] && formDataReseller['paymentDetails']['paymentMode']['value'] == 'direct' ? 'required' : ''"
                    mode="eager"
                    data-vv-validate-on="change"></v-select>
                    <span v-if="errors.has('Billing Entity')" class="select-required-error--span span-text-validation"> Required field </span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Bank</label>
                    <vs-input
                      name="Bank"
                      class="w-full"
                      v-model="formDataReseller['paymentDetails']['bank']" />
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Bank A/C No.</label>
                    <vs-input
                      name="Bank A/C No"
                      class="w-full"
                      v-model="formDataReseller['paymentDetails']['bankACNo']" />
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">SWIFT Code</label>
                    <vs-input
                      name="SWIFT Code"
                      class="w-full"
                      v-model="formDataReseller['paymentDetails']['swiftCode']" />
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row">
                  <vs-button :disabled="!flags['previousTabsValid']" class="ml-auto" button="submit" type="filled" icon-pack="feather" icon="icon-save">Save</vs-button>
                </div>
              </form>
            </vs-tab>

            <vs-tab label="Review Details" :disabled="!flags['allTabsValid']">
              <hr class="mt-2">
              <div class="tab-text">
                <div class="vx-row mt-8">
                  <div class="vx-col">
                    <h5 class="tab-title">Registrar Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4" v-for="(regDetail, index) in formDataReseller['registrarDetails']" :key="`ParentReg-${index}`">
                    <label class="vs-input--label inline-flex pb-2">Parent Registrar:</label>
                    <!-- <div class="flex"> -->
                      <span class="review-details-data ml-2">{{ regDetail['parentRegistrar'] ? regDetail['parentRegistrar']['label'] : '' }}</span>
                    <!-- </div> -->
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row mt-6">
                  <div class="vx-col">
                    <h5 class="tab-title">Reseller Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Name: </label>
                    <span class="review-details-data ml-2">{{ formDataReseller['resellerDetails']['resellerShortName'] }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Account Manager:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['resellerDetails']['accountManager'] ? formDataReseller['resellerDetails']['accountManager']['label'] : '' }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Country:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['resellerDetails']['country'] ? formDataReseller['resellerDetails']['country']['label'] : '' }}</span>
                  </div>
                  
                  <div class="vx-col w-1/4">
                  <label class="vs-input--label inline-flex pb-2">Website:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['resellerDetails']['website'] }}</span>
                  </div>
                </div>

                <!-- TODO: Fix height for when selected options > 1 -->
                <div class="vx-row mt-4">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Nameservers:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['resellerDetails']['nameservers'] && formDataReseller['resellerDetails']['nameservers'].length ? formDataReseller['resellerDetails']['nameservers'].map(x => x.label).join(', ') : '' }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Group Entity:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['resellerDetails']['groupEntity'] ? formDataReseller['resellerDetails']['groupEntity']['label'] : '' }}</span>
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row mt-6">
                  <div class="vx-col">
                    <h5 class="tab-title">Point of Contact Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-4" v-for="(contactDetail, index) in formDataReseller['resellerDetails']['contactDetails']" :key="`ContactDetail-${index}`">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Contact {{ index + 1 }} Name:</label>
                    <span class="review-details-data ml-2">{{ contactDetail['name'] }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Contact {{ index + 1 }} Email:</label>
                    <span class="review-details-data ml-2">{{ contactDetail['email'] }}</span>
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row mt-8">
                  <div class="vx-col">
                    <h5 class="tab-title">Payment Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4">
                  <label class="vs-input--label inline-flex pb-2">List Based:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['listBased'] ? formDataReseller['paymentDetails']['listBased']['label'] : '' }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">List Frequency:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['listFrequency'] ? formDataReseller['paymentDetails']['listFrequency']['label'] : '' }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Payment Mode:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['paymentMode'] ? formDataReseller['paymentDetails']['paymentMode']['label'] : '' }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Custom List:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['customList'] ? formDataReseller['paymentDetails']['customList']['label'] : '' }}</span>
                  </div>
                </div>

                <div class="vx-row mt-4">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Billing Entity:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['billingEntity'] ? formDataReseller['paymentDetails']['billingEntity']['label'] : '' }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Bank:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['bank'] }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Bank A/C No.:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['bankACNo'] }}</span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">SWIFT Code:</label>
                    <span class="review-details-data ml-2">{{ formDataReseller['paymentDetails']['swiftCode'] }}</span>
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row justify-end">
                  <vs-button type="filled" icon-pack="feather" icon="icon-save" @click="submit()">Submit</vs-button>
                </div>
              </div>
              <!--  -->
            </vs-tab>
          </vs-tabs>
        </div>
      </vx-card>
    </div>
    <!--  -->

    <!-- Group Entity Popup -->
    <vs-popup :active.sync="groupEntityPopupActive" title="" class="group-entity-popup">
      <vx-card>
        <div class="vx-row flex-wrap px-5 justify-center mt-6">
          <h2 class="text-center"> Add Group Entity </h2>
        </div>

        <div class="vx-row flex-wrap px-5 mt-6">
          <vs-input
            class="w-full mx-auto px-6"
            name="New Group Entity"
            placeholder="New Group Entity"
            v-model="newGroupEntity" />
        </div>

        <div class="vx-row mt-6">
          <vs-button class="mx-auto" type="filled" icon-pack="feather" @click="saveNewGroupEntity()" :disabled="!newGroupEntity">Add</vs-button>
        </div>
      </vx-card>
    </vs-popup>
    <!--  -->

    <!-- Error Prompt -->
    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
      <div class="con-content" slot="content">
        <p>Please solve the following errors: <br><ul>{{ customPromptError }}</ul></p>
      </div>
    </custom-prompt>
    <!--  -->
  </div>
</template>

<script>
import vSelect from "vue-select";
import CustomPrompt from "@/components/CustomPrompt.vue";
import Treeselect from "@riophae/vue-treeselect";

// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  name: 'AddReseller',
  components: {
    "v-select": vSelect,
    CustomPrompt,
    Treeselect
  },
  data() {
    return {
      formDataReseller: {
        // Reseller Details
        resellerDetails: {
          accountManager: null,
          resellerShortName: null,
          country: null,
          website: null,
          groupEntity: null,
          nameservers: null,
          contactDetails: [{
            name: null,
            email: null
          }],
        },
        // Registrar Details
        registrarDetails: [{
          parentRegistrar: null,
          accountManager: null,
          country: null,
          cnicIanaIDs: [{
            cnic_id: '',
            iana_id: ''
          }],
          viewDetails: true
        }],
        // Payment Details
        paymentDetails: {
          listBased: null,
          listFrequency: null,
          paymentMode: null,
          customList: null,
          billingEntity: null,
          bank: null,
          bankACNo: null,
          swiftCode: null
        }
      },
      formInit: {
        customUniqueRegs: [],
        nameServers: [],
        groupEntity: [],
        billingEntity: []
      },
      customPrompt: {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      },
      customPromptError: null,
      groupEntityPopupActive: false,
      newGroupEntity: null,
      regDetailsIndex: null,
      flags: {
        previousTabsValid: false,
        allTabsValid: false
      }
    }
  },
  created() {
    this.getCustomUniqueRegs();
    // this.getNameservers();
    this.getGroupEntities();
    this.getBillingEntities();
  },
  watch: {
    // TODO: Fix later
    computedGroupEntityPopupActive(val) {
      if(!val) {
        this.newGroupEntity = null;
      }
    },
    formGroupEntity() {
      if(this.formInit['groupEntity'].length) {
        return this.formInit['groupEntity'].map(x => {
          return {
            label: x['name'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    }
  },
  computed: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    showRegDetails() {
      return this.formDataReseller['registrarDetails'].some(x => !x['viewDetails']);
    },
    formCustomUniqueRegs() {
      if(this.formInit['customUniqueRegs'].length) {
        return this.formInit['customUniqueRegs'].map(x => {
          return {
            label: x['unique_registrar_shortname'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    },
    formAMs() {
      return this.$store.getters.formAMs;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formNameservers() {
      if(this.formInit['nameServers'].length) {
        return this.formInit['nameServers'].map(x => {
          return {
            label: x['name'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    },
    formGroupEntity() {
      if(this.formInit['groupEntity'].length) {
        return this.formInit['groupEntity'].map(x => {
          return {
            label: x['name'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    },
    formBooleanValues() {
      return [{
        label: 'Yes',
        value: 'yes'
      },
      {
        label: 'No',
        value: 'no'
      }]
    },
    // TODO: Add NA to the list
    formListFrequency() {
      return [{
        label: 'NA',
        value: null
      },
      {
        label: 'Monthly',
        value: 'monthly'
      },
      {
        label: 'Quarterly',
        value: 'quarterly'
      }]
    },
    formPaymentMode() {
      return [{
        label: 'CNIC',
        value: 'cnic'
      },
      {
        label: 'Direct',
        value: 'bank'
      }]
    },
    formBillingEntity() {
      if(this.formInit['billingEntity'].length) {
        return this.formInit['billingEntity'].map(x => {
          return {
            label: x['name'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    },
    characterCount() {
      return 'Character Count: ' + (this.formDataReseller['resellerDetails']['resellerShortName'] ? this.formDataReseller['resellerDetails']['resellerShortName'].length : 0) + '/50';
    },
    // computedGroupEntityPopupActive: {
    //   // getter
    //   get: function () {
    //     if(this.groupEntityPopupActive) return true;
    //     return false;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     if(!newValue) {
    //       this.newGroupEntity = null;
    //     }
    //   }
    // }
  },
  watch: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    }
  },
  methods: {
    nameserverList({ action, searchQuery, callback }) {
      let registrarName = this.formDataReseller.registrarDetails[0].parentRegistrar ? this.formDataReseller.registrarDetails[0].parentRegistrar.label : null;

      if(registrarName) {
        if (action === ASYNC_SEARCH) {
          this.$axiosSecure.get(`/nameservers/bi/${registrarName}/${searchQuery}`)
          .then(response => {
            let nameserverList = response.data;
  
            var transformedNameserverList = [];
  
            for (var nameserver of nameserverList) {
              var obj = {
                id: nameserver.name,
                label: nameserver.name,
              }
  
              transformedNameserverList.push(obj);
            }
  
            callback(null, transformedNameserverList);
          })
          .catch(error => {
              console.log("Entity Search Error", error);
          })
        }
      } else {
        return [];
      }
    },
    addContactDetails() {
      if(this.formDataReseller['resellerDetails']['contactDetails'].length < 3) {
        this.formDataReseller['resellerDetails']['contactDetails'].push({
          name: null,
          email: null
        });
      }
    },
    removeContactDetail(index) {
      this.formDataReseller['resellerDetails']['contactDetails'].splice(index, 1);
    },
    // NOTE: Move to next tab -> To Billing & Payment Details
    nextToPayment() {
      // NOTE: Validate only inputs under Reg & Res Tab on click of Next
      let validationResults = [
        this.$validator.validate('Parent Registrar-0'),
        this.$validator.validate('Reseller Short Name'),
        this.$validator.validate('Reseller Account Manager'),
        this.$validator.validate('Reseller Website'),
        this.$validator.validate('Group Entity'),
        this.$validator.validate('Contact Name-0'),
        this.$validator.validate('Contact Email-0'),
      ]

      Promise.all(validationResults).then(async (valid) => {
        if(!valid.includes(false)) {
          // TODO: Fix the click hack
          this.$set(this.flags, 'previousTabsValid', true);

          setTimeout(() => {
            var ul = document.getElementsByClassName("ul-tabs")[0];
            ul.children[1].getElementsByClassName("vs-tabs--btn")[0].click();
          }, 1000);

          this.$validator.reset();
        } else {
          setTimeout(() => {
            var ul = document.getElementsByClassName("ul-tabs")[0];
            ul.children[0].getElementsByClassName("vs-tabs--btn")[0].click();
          }, 1000);
          
          var errors = this.errors.collect();
        }
      })
    },
    backToResellerAndRegDetails() {
      setTimeout(() => {
        var ul = document.getElementsByClassName("ul-tabs")[0];
        ul.children[0].getElementsByClassName("vs-tabs--btn")[0].click();
      }, 1000)
    },
    setAllToView(setIndex) {
      this.formDataReseller['registrarDetails'].map((x, index) => {
        if(index !== setIndex) {
          x['viewDetails'] = true;
        }
      })

      this.regDetailsIndex = null;
      // this.getNameservers();
    },
    toggleViewDetails(index) {
      this.setAllToView(index);
      let customUniqueReg = this.formInit['customUniqueRegs'].find(x => x.id == this.formDataReseller['registrarDetails'][index]['parentRegistrar'].value);
      this.regDetailsIndex = index;
      this.formDataReseller['registrarDetails'][index]['viewDetails'] = !this.formDataReseller['registrarDetails'][index]['viewDetails'];
      this.formDataReseller['registrarDetails'][index]['accountManager'] = customUniqueReg.unique_registrar_am;
      this.formDataReseller['registrarDetails'][index]['country'] = customUniqueReg.unique_registrar_country_name;
      this.formDataReseller['registrarDetails'][index]['cnicIanaIDs'] = (customUniqueReg.cnic_id || customUniqueReg.iana_id) ? (customUniqueReg.cnic_id ? customUniqueReg.cnic_id.split(',').map((x, index) => {
        return {
          cnic_id: x,
          iana_id: customUniqueReg.iana_id ? customUniqueReg.iana_id.split(',')[index] : null
        }
      }) : customUniqueReg.iana_id.split(',').map((x, index) => {
        return {
          cnic_id: customUniqueReg.cnic_id ? customUniqueReg.cnic_id.split(',')[index] : null,
          iana_id: x
        }
      })) :
      [{
        cnic_id: null,
        iana_id: null
      }]
    },
    addParentReg() {
      this.formDataReseller['registrarDetails'].push({
          parentRegistrar: '',
          accountManager: '',
          country: '',
          cnicIanaIDs: [{
            cnic_id: '',
            iana_id: ''
          }],
          viewDetails: true
        })
    },
    removeParentReg(index) {
      this.formDataReseller['registrarDetails'].splice(index, 1);
    },
    addNewGroupEntity() {
      this.groupEntityPopupActive = true;
    },
    saveNewGroupEntity() {
      this.groupEntityPopupActive = false;

      this.$axiosSecure
        .post('/group-entities', { name: this.newGroupEntity })
        .then((response) => {
          if(response.data.type == 'Success') {
            this.getGroupEntities();

            this.$vs.dialog({
              color: 'success',
              title: 'Success',
              text: 'Group Entity added successfully!',
              acceptText: 'Close',
              accept: () => {},
            });
          } else {
            let liStr = '';
            response.data.message.forEach((el, index) => {
              liStr += `${index+1}. ${el}<br>`
            })
            this.customPromptError = liStr;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          }
        })
        .catch((error) => {
          let liStr = '';
          error.response.data.message.forEach((el, index) => {
            liStr += `${index+1}. ${el}<br>`
          })
          this.customPromptError = liStr;
          this.customPrompt["type"] = "error";
          this.customPrompt["classList"] = "danger-prompt";
          this.customPrompt["color"] = "danger";
          this.customPrompt["activePrompt"] = true;
        })
    },
    async getCustomUniqueRegs() {
      let customUniqueRegs = await this.$axiosSecure.get('/v2/unique-registrars/custom');
      this.formInit['customUniqueRegs'] = customUniqueRegs.data;
    },
    async getNameservers() {
      let registrarName = this.formDataReseller.registrarDetails[0].parentRegistrar.label;
      console.log('registrarName :>> ', registrarName);
      let nameservers = await this.$axiosSecure.get(`/nameservers/bi/${registrarName}`);
      this.formInit['nameServers'] = nameservers.data;
    },
    async getGroupEntities() {
      let groupEntities = await this.$axiosSecure.get('/group-entities');
      this.formInit['groupEntity'] = groupEntities.data;
    },
    async getBillingEntities() {
      let billingEntities = await this.$axiosSecure.get('/billing-entities');
      this.formInit['billingEntity'] = billingEntities.data;
    },
    formPayload() {
      return {
        unique_registrar_id: this.formDataReseller['registrarDetails'].map(x => x.parentRegistrar.value),
        unique_registrar_name: this.formDataReseller['registrarDetails'].map(x => x.parentRegistrar.label),
        name: this.formDataReseller['resellerDetails']['resellerShortName'],
        am_id: this.formDataReseller['resellerDetails']['accountManager'] ? this.formDataReseller['resellerDetails']['accountManager']['value'] : null,
        country_id: this.formDataReseller['resellerDetails']['country'] ? this.formDataReseller['resellerDetails']['country']['value'] : null,
        website: this.formDataReseller['resellerDetails']['website'],
        group_entity_id: this.formDataReseller['resellerDetails']['groupEntity'].value,
        billing_entity_id: this.formDataReseller['paymentDetails']['billingEntity'] ? this.formDataReseller['paymentDetails']['billingEntity'].value : null,
        payment_mode: this.formDataReseller['paymentDetails']['paymentMode'] ? this.formDataReseller['paymentDetails']['paymentMode'].value : null,
        list_based: this.formDataReseller['paymentDetails']['listBased'] ? this.formDataReseller['paymentDetails']['listBased'].value : null,
        list_frequency: this.formDataReseller['paymentDetails']['listFrequency'] ? this.formDataReseller['paymentDetails']['listFrequency'].value : null,
        custom_list: this.formDataReseller['paymentDetails']['customList'] ? this.formDataReseller['paymentDetails']['customList'].value : null,
        bank: this.formDataReseller['paymentDetails']['bank'],
        account_number: this.formDataReseller['paymentDetails']['bankACNo'],
        swift_code: this.formDataReseller['paymentDetails']['swiftCode'],
        // nameserver : this.formDataReseller['resellerDetails']['nameservers'] ? (this.formDataReseller['resellerDetails']['nameservers'].length && this.formDataReseller['resellerDetails']['nameservers'][0]['value'] !== null ? this.formDataReseller['resellerDetails']['nameservers'].map(x => x.label) : null) : [],
        nameserver: this.formDataReseller['resellerDetails']['nameservers'],
        poc_details: this.formDataReseller['resellerDetails']['contactDetails']
      }
    },
    save() {
      this.$validator.validate().then(async (valid) => {
        if(valid) {
          this.flags['allTabsValid'] = true;

          setTimeout(() => {
            var ul = document.getElementsByClassName("ul-tabs")[0];
            ul.children[2].getElementsByClassName("vs-tabs--btn")[0].click();
          }, 1000);
        } else {
          setTimeout(() => {
            var ul = document.getElementsByClassName("ul-tabs")[0];
            ul.children[1].getElementsByClassName("vs-tabs--btn")[0].click();
          }, 1000)
          var errors = this.errors.collect();
        }
      })
    },
    async submit() {
      // TODO: Remove comment when validation is fixed
      // let validationResults = [
      //   this.$validator.validate('Parent Registrar-0'),
      //   this.$validator.validate('Reseller Short Name'),
      //   this.$validator.validate('Reseller Website'),
      //   this.$validator.validate('Group Entity'),
      //   this.$validator.validate('Contact Name-0'),
      //   this.$validator.validate('Contact Email-0'),
      //   this.$validator.validate('Billing Entity'),
      // ]

      // Promise.all(validationResults).then(async (valid) => {
      //   if(!valid.includes(false)) {
          let payload = await this.formPayload();

          await this.$axiosSecure.post('/new-resellers', payload)
          .then((response) => {
            if(response.data.type == 'Success') {
              this.resetForm();

              this.$vs.dialog({
                color: 'success',
                title: 'Success',
                text: 'Reseller added successfully!',
                acceptText: 'Close',
                accept: () => {},
              });

              // NOTE: Reset Form validation after submit
              this.$validator.pause()
              this.$nextTick(() => {
                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
              })
            } else {
              let liStr = '';
              response.data.message.forEach((el, index) => {
                liStr += `${index+1}. ${el}<br>`
              })
              this.customPromptError = liStr;
              this.customPrompt["type"] = "error";
              this.customPrompt["classList"] = "danger-prompt";
              this.customPrompt["color"] = "danger";
              this.customPrompt["activePrompt"] = true;
            }
          })
          .catch((error) => {
            let liStr = '';
            error.response.data.message.forEach((el, index) => {
              liStr += `${index+1}. ${el}`
            })
            this.customPromptError = liStr;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          })
      //   } else {
      //     var errors = this.errors.collect();
      //   }
      // })
    },
    resetForm() {
      this.formDataReseller = {
        // Reseller Details
        resellerDetails: {
          accountManager: null,
          resellerShortName: null,
          country: null,
          website: null,
          groupEntity: null,
          nameservers: null,
          contactDetails: [{
            name: null,
            email: null
          }],
        },
        // Registrar Details
        registrarDetails: [{
          parentRegistrar: null,
          accountManager: null,
          country: null,
          cnicIanaIDs: [{
            cnic_id: '',
            iana_id: ''
          }],
          viewDetails: true
        }],
        // Payment Details
        paymentDetails: {
          listBased: null,
          listFrequency: null,
          paymentMode: null,
          customList: null,
          billingEntity: null,
          bank: null,
          bankACNo: null,
          swiftCode: null
        }
      };
      this.formInit = {
        customUniqueRegs: [],
        nameServers: [],
        groupEntity: [],
        billingEntity: []
      };
      this.customPrompt = {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      };
      this.groupEntityPopupActive = false,
      this.newGroupEntity = null,
      this.regDetailsIndex = null,
      this.flags = {
        previousTabsValid: false,
        allTabsValid: false
      };
      this.backToResellerAndRegDetails();
    }
  },
  beforeDestroy() { this.$validator.reset() }
}
</script>